<template>
  <div class="msgManage">
    <div class="breadcrumb">消息管理</div>
    <div class="search">
      消息接收时间：
      <div class="time_msg">
        <el-date-picker
          v-model="beginAt"
          placeholder="请选择开始时间"
          class="qizhiDate"
        ></el-date-picker>
      </div>
      -
      <div class="time_msg">
        <el-date-picker
          v-model="endAt"
          placeholder="请选择结束时间"
          class="qizhiDate"
        ></el-date-picker>
      </div>
      <el-button @click="getMsgList">筛选</el-button>
    </div>

    <div class="com-list">
      <div class="noData" v-show="this.totalCount == 0">暂无数据</div>
      <div v-for="item in list" class="item_msg">
        <div class="headImg_msg">
          <img :src="item.headUrl" class="headImg_msg" v-if="item.headUrl" />
        </div>
        <div class="text_msg_box">
          <p class="name_msg">{{ item.username }}</p>
          <p>{{ item.message }}</p>
        </div>
        <span class="time_msg">{{ item.time }}</span>
      </div>
    </div>
    <div class="pagination">
      <el-pagination
        v-show="this.totalCount > 0"
        layout="prev, pager, next, jumper"
        :page-size="10"
        :current-page="currentPage"
        :total="totalCount"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      beginAt: new Date(),
      endAt: new Date(),
      list: [],
      totalCount: 0,
      currentPage: 1,
    };
  },
  mounted() {
    this.getMsgList();
  },

  methods: {
    //获取消息列表
    getMsgList() {
      let url = this.$util.domain + "/adminapi/v1/secretary/receieve/list";
      let startTime = new Date(
        this.beginAt.format("yyyy/MM/dd 00:00")
      ).getTime();
      let endTime = new Date(this.endAt.format("yyyy/MM/dd 23:59")).getTime();
      if (startTime > endTime) {
        this.$util.errorMsg("开始时间应小于结束时间");
        return;
      }
      this.$http({
        url,
        method: "GET",
        params: {
          endTime,
          startTime,
          pageSize: 10,
          pageIndex: this.currentPage,
        },
      }).then((response) => {
        this.list = [];
        this.totalCount = 0;
        if (response.data.error == 10000) {
          let data = response.data.data.data;
          this.totalCount = response.data.data.totalPage * 10;
          if (data && data.length) {
            data.forEach((item) => {
              this.list.push({
                headUrl: item.headUrl,
                message: item.message,
                username: item.username,
                time: item.messageCreateTime
                  ? new Date(item.messageCreateTime).format("yyyy.MM.dd hh:mm")
                  : "",
              });
            });
          }
        }
      });
    },
    //分页回调
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getMsgList();
    },
  },
};
</script>
<style>
.msgManage {
  min-height: calc(100vh - 60px);
}

.msgManage .el-select {
  display: inline-block;
}

.msgManage .el-input {
  display: inline-block;
  width: auto;
}

.msgManage .el-button {
  display: inline-block;
}

.msgManage .el-button + .el-button {
  margin-left: 0;
}

.search {
  margin-left: 30px;
}

.dynamics {
  margin-top: 20px;
}

.time_msg {
  display: inline-block;
}

.item_msg {
  border: solid 1px #e3e3e3;
  margin-bottom: 20px;
  padding: 20px;
  box-sizing: border-box;
  position: relative;
}

.headImg_msg {
  display: inline-block;
  width: 80px;
  height: 80px;
  border-radius: 50%;
}

.name_msg {
  vertical-align: top;
  margin-bottom: 20px;
}

.text_msg_box {
  display: inline-block;
  margin-left: 15px;
  width: 70%;
  height: 100%;
  vertical-align: top;
}

span.time_msg {
  margin-left: 15px;
  display: inline-block;
  vertical-align: top;
}

.noData {
  color: #5e6d82;
  text-align: center;
  margin-top: 20px;
  height: 50px;
  line-height: 50px;
  border: solid 1px #e3e3e3;
}
</style>



// WEBPACK FOOTER //
// msgManage.vue?1ec2ff72